import { Theme } from "@material-ui/core"
import makeStyles from "@material-ui/core/styles/makeStyles"
import React, { useContext } from "react"
import SweetAlert from "react-bootstrap-sweetalert"
import { AppContext } from "Views/Home/context"

export const useStyles = makeStyles((theme: Theme) => ({
    "@global": {
        ".btn": {
            display: "inline-block",
            padding: "12px 30px",
            fontSize: 14,
            fontWeight: 400,
            textAlign: "center",
            whiteSpace: "nowrap",
            verticalAlign: "middle",
            cursor: "pointer",
            userSelect: "none",
            color: "white",
            textDecoration: "none",
            border: "1px solid transparent !important",
            "&:focus": {
                outline: "1px solid transparent !important",
            },
        },
    },
    cancelBtn: {
        backgroundColor: "#f44336",
        color: "white",
        marginRight: '100px !important',
        "&:hover": {
            backgroundColor: "#f44336",
        },
    },
    confirmBtn: {
        backgroundColor: "#4caf50",
        color: "white",
        "&:hover": {
            backgroundColor: "#4caf50",
        },
    },
}))
const Alert = () => {
    const { appModal } = useContext(AppContext)
    const {
        type, title, show, onConfirm,
        onCancel,
        showCancel = false,
        timeout,
        children = null,
        customButtons,
    } = appModal
    const classes = useStyles()
    return (
        <SweetAlert
            type={type}
            title={title}
            show={show}
            onConfirm={onConfirm}
            timeout={timeout}
            showCancel={showCancel}
            confirmBtnText="确定"
            cancelBtnText="取消"
            onCancel={onCancel}
            customButtons={customButtons}
            cancelBtnCssClass={classes.cancelBtn}
            confirmBtnCssClass={classes.confirmBtn}
        >
            {children}
        </SweetAlert>
    )
}

export default Alert
